/** Runtime config: window.__CONFIG__ (served by the Worker from wrangler vars) → VITE_* → localhost. */
import { COUNTRY_CODES } from '@platform/shared';

declare global {
  interface Window {
    __CONFIG__?: { API_URL?: string; WS_URL?: string; COUNTRY?: string };
  }
}

const w = window.__CONFIG__ ?? {};
export const API_URL = (w.API_URL || import.meta.env.VITE_API_URL || 'http://localhost:3000').replace(/\/$/, '');
export const WS_URL = w.WS_URL || import.meta.env.VITE_WS_URL || 'ws://localhost:3001';

/**
 * The visitor's country from their IP (Cloudflare geolocation, set by the Worker), or '' when unknown:
 * local dev, Tor (T1) or an unknown address (XX). VITE_COUNTRY overrides it for testing.
 */
const cc = String(w.COUNTRY || import.meta.env.VITE_COUNTRY || '').toUpperCase();
export const IP_COUNTRY: string = COUNTRY_CODES.includes(cc) ? cc : '';
